'use client'

import { Autoplay, Navigation, Pagination } from "swiper/modules";
import { Swiper, SwiperSlide } from "swiper/react";

import sponsor1 from '../../assets/images/brand/1.png';
import sponsor2 from '../../assets/images/brand/2.png';
import sponsor3 from '../../assets/images/brand/3.png';
import sponsor4 from '../../assets/images/brand/4.jpeg';
import sponsor5 from '../../assets/images/brand/5.jpg';
import sponsor6 from '../../assets/images/brand/6.jpg';
import sponsor7 from '../../assets/images/brand/7.png';
import sponsor8 from '../../assets/images/brand/8.png';
import sponsor9 from '../../assets/images/brand/9.PNG';
import sponsor10 from '../../assets/images/brand/10.PNG';
import sponsor11 from '../../assets/images/brand/11.PNG';
import sponsor12 from '../../assets/images/brand/12.png';
import sponsor13 from '../../assets/images/brand/13.png';
import sponsor14 from '../../assets/images/brand/14.jpg';
import sponsor15 from '../../assets/images/brand/15.png';

const swiperOptions = {
    modules: [Autoplay, Pagination, Navigation],
    spaceBetween: 100,
    slidesPerView: 5,
    loop: true,
    navigation: {
        nextEl: "#brand-one__swiper-button-next",
        prevEl: "#brand-one__swiper-button-prev"
    },
    autoplay: { delay: 5000 },
    breakpoints: {
        0: {
            spaceBetween: 30,
            slidesPerView: 1
        },
        375: {
            spaceBetween: 30,
            slidesPerView: 1
        },
        575: {
            spaceBetween: 30,
            slidesPerView: 2
        },
        767: {
            spaceBetween: 50,
            slidesPerView: 3
        },
        991: {
            spaceBetween: 50,
            slidesPerView: 4
        },
        1199: {
            spaceBetween: 100,
            slidesPerView: 5
        },
    }
};

export default function BrandSlider1() {
    const sponsors = [
        sponsor1, sponsor2, sponsor3, sponsor4, sponsor5,
        sponsor6, sponsor7, sponsor8, sponsor9, sponsor10,
        sponsor11, sponsor12, sponsor13, sponsor14, sponsor15
    ];

    return (
        <Swiper {...swiperOptions} className="thm-swiper__slider swiper-container">
            <div className="swiper-wrapper">
                {sponsors.map((sponsor, index) => (
                    <SwiperSlide className="swiper-slide" key={index}>
                        <div
                            style={{
                                width: '140px',
                                height: '85px',
                                display: 'flex',
                                justifyContent: 'center',
                                alignItems: 'center',
                                margin: 'auto'
                            }}
                        >
                            <img
                                src={sponsor}
                                alt={`Sponsor ${index + 1}`}
                                style={{
                                    width: '100%',
                                    height: '100%',
                                    objectFit: 'contain'
                                }}
                            />
                        </div>
                    </SwiperSlide>
                ))}
            </div>
        </Swiper>
    );
}
